import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import router from '@/router/index'
import Nprogress from 'nprogress';
import qs from 'qs'
Vue.use(Vuex)
const state = {
    acsList: [],
    acsDevicesList:[],
    acsDeviceDetailList:[],
}

const mutations = {
    CLEAR_ACS_STATE(state) {
        state.acsList = [];
        state.acsDevicesList = [];
        state.acsDeviceDetailList = [];
    },
    SET_ACS_DATA(state, data) {
        state.acsList = data;
    },
    SET_ACS_DEVICES_DATA(state,data){
        state.acsDevicesList = data;
    },
    SET_ACS_DEVICE_DETAIL(state,data){
        state.acsDeviceDetailList = data;

    },
    UPDATE_ACS_DEVICE_DETAIL(state,data){
        var acsDeviceData = data.acsDevices;
        var deviceId = data.deviceId;
        if (Object.keys(state.acsDevicesList).length != 0 && state.acsDevicesList != 'noData') {
            if(deviceId != undefined && deviceId != null && deviceId !=''){
                var index = state.acsDevicesList.acsDevices.findIndex(devices => devices.id == deviceId);
                if(index != -1){
                    state.acsDevicesList.acsDevices.splice(index, 1, acsDeviceData);
                }
            }
        }
        if (Object.keys(state.acsDeviceDetailList).length != 0 && state.acsDeviceDetailList != 'noData') {
            if(deviceId != undefined && deviceId != null && deviceId !=''){
             console.log("before: ",state.acsDeviceDetailList.acsDeviceData);
             state.acsDeviceDetailList.acsDeviceData = acsDeviceData;
                // Vue.set(state.acsDeviceDetailList,'acsDeviceData', acsDeviceData);
                console.log("after: ",state.acsDeviceDetailList.acsDeviceData);
            }
        }
    }
}

const actions = {

    clearAcsState({
        commit,
    }) {
        commit('CLEAR_ACS_STATE')
    },
    fetchAcsData({
        commit,
    }) {
        Nprogress.start()
        axios.get('/acs/index/true')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                  } else {
                    commit('SET_ACS_DATA', res.data.message)
                  }
            })
            .catch(error => console.log(error))
    },
    fetchAcsDevicesData({
        commit,
    },postData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        axios
            .post("/acs/acs_devices", qs.stringify(postData, {
                parseArrays: false
            }))
            .then(res => {
                loader.hide();
                if (res.data.status == "redirect") {
                    router.push(res.data.message);
                } else {
                commit('SET_ACS_DEVICES_DATA', res.data.message)
                }
            })
            .catch(error => console.log(error))
            
    },
    refreshAcsDevicesData({
        commit,
    },postData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        axios
            .post("/acs/refresh_acs_devices")
            .then(res => {
                loader.hide();
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                //commit('SET_ACS_DEVICES_DATA', res.data.message)
                }
            })
            .catch(error => console.log(error))
            
    },
    fetchAcsDevicesFaultsData({
        commit,
    },postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/acs/acs_devices_faults", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => console.log(error))
            });
    },
    fetchAcsDeviceDetail({
        commit,
    }, postData) {
        let loader = Vue.$loading.show({
            canCancel: false,
          });
        axios
            .post("/acs/acs_device_detail", qs.stringify(postData, {
                parseArrays: false
            }))
            .then(res => {
                loader.hide()
            if (res.data.status == "redirect") {
                router.push("/dashboard");
                } else {
                    commit('SET_ACS_DEVICE_DETAIL', res.data.message)
                }

            })
            .catch(error => console.log(error));
    },
    updateDeviceDetail({commit,dispatch},postData){
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
              });
        axios
            .post("/acs/edit_acs_devices", qs.stringify(postData, {
                parseArrays: false
            }))
            .then(res => {
                loader.hide()
                if(res.data.status == "error"){
                    reject(res.data.message);
                    return;
                }

                commit('UPDATE_ACS_DEVICE_DETAIL', res.data);
                resolve(res.data);
            })
            .catch(error => console.log(error));
        });
    },
    assignDevice({commit,dispatch},postData){
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
              });
        axios
            .post("/acs/assign_device", qs.stringify(postData, {
                parseArrays: false
            }))
            .then(res => {
                loader.hide()
                if(res.data.status == "error"){
                    reject(res.data.message);
                    return;
                }
                resolve(res.data);
            })
            .catch(error => console.log(error));
        });
    },
    provisionTo({commit,dispatch},postData){
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
              });
        axios
            .post("/acs/provision_to", qs.stringify(postData, {
                parseArrays: false
            }))
            .then(res => {
                loader.hide()
                if(res.data.status == "error"){
                    reject(res.data.message);
                    return;
                }

                commit('UPDATE_ACS_DEVICE_DETAIL', res.data);
                resolve(res.data);
            })
            .catch(error => console.log(error));
        });
    },
    acsDeviceActions({commit,dispatch},postData){
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
              });
        axios
            .post(postData.url, qs.stringify(postData, {
                parseArrays: false
            }))
            .then(res => {
                loader.hide()
                if(res.data.status == "error"){
                    reject(res.data.message);
                    return;
                }
                //commit('UPDATE_ACS_DEVICE_DETAIL', res.data);
                resolve(res.data);
            })
            .catch(error => console.log(error));
        });
    },
  
}

const getters = {
    acsGetter: state => {
        return state.acsList;
    },
    acsDevicesGetter: state => {
        return state.acsDevicesList;
    },
    acsDeviceDetailGetter: state => {
        return state.acsDeviceDetailList;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
